import React from 'react';
import {AutocompleteChangeReason} from "@mui/material";
import {AutocompleteOption} from "../../../SortFilter/interfaces";
import {useGetRequestAutocompleteOptions} from "../../../../hooks/request/options/useGetRequestAutocompleteOptions";
import { FilterAutocomplete } from "../FilterAutocomplete/FilterAutocomplete";

type BoundDataDrivenAutocompleteProps<T> =  {
  requestUrl: string;
  queryParams?: Record<string, unknown>;
  shouldAbort?: boolean;
  name: string;
  value?: string | number | null;
  label: string;
  onChange: (newQuery: T) => void;
}

const BoundDataDrivenAutocomplete = <T,>({
  requestUrl,
  queryParams,
  shouldAbort,
  name,
  value = '',
  label,
  onChange
}: BoundDataDrivenAutocompleteProps<T>) => {

  const handleChange = (_event: React.SyntheticEvent<Element, Event>, newValue: AutocompleteOption, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onChange({
        [name]: newValue?.id ?? ''
      } as unknown as T);
    }
  };

  const { options, isLoading } = useGetRequestAutocompleteOptions({ requestUrl, queryParams, shouldAbort });

  return (
    <FilterAutocomplete
      label={label}
      value={value}
      options={options}
      loading={isLoading}
      onChange={handleChange}
    />
  )
};


export { BoundDataDrivenAutocomplete };